 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		37: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		37: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"3d81276e2d47b1e065593ec2bc39a6e639c24d24","1":"a7679458f757b8361ace13a33f056b678a76b46c","2":"061b8fceb71bb8d81c977d3bd31bb3ad771b6691","3":"86829105fcece2d88e47c1369debf01e4cd83911","4":"f9cd8ecc1fbc449bd6fdcb9cc73dd4c3735f67ac","5":"19ff34cb0f310556ebd1dd90413ea24ae873f714","6":"8b7dde43d5b7ffc0c27e8df6a260c016dd21b919","7":"b71876d7f0cc283bc2c0951a83e9797af1c0ad31","8":"993423d7e1514d975d30f830e77c1bd06b0e5123","9":"a2a67fd245292ab39c145de116d3036550db830c","10":"cb1608f2","11":"f83b2f6a4429c64aba1966f20a36b987a5dc610e","12":"6d45fb1597c1325fb4b797d476d6c6602382e693","13":"71ac299a32e43abe3eb7a512f79e44c5a02b3eba","14":"5e8c72a52bfd502db71822c4ede0fd5e181aae8c","15":"0235f48bb9b1fadbc49ebe2f6ba5269ac5b94cc8","16":"styles","17":"278ea1445bebd52b140a7a1a064e0d7d66ac2bcc","18":"0119a905e4cf4bb074f4e7592dc2e4e1125c92c6","19":"38c353afb757743b76bdc5d8e51964c745e206fa","20":"4974abce5f84d24f9784d949b3640f81a9a1d3e9","21":"c6b56806421cf466d322078bed31b1b6b618ad13","22":"6c02620f0fb14ecbb80c1d7a1503d54c3d1f0052","23":"5742af7634bdd1f87b1f2e0421e426bfa4fc31c1","24":"7ab772c218f0b94be6d577356d49011e94b4e946","25":"c5a0548ced652622677832e627f1813f7ecbbb40","26":"component---src-pages-admin-users-sender-details-js","27":"0961343f57343142236bf89ad27709698071d114","28":"939e8a034d55a51d1fb271fb1ab6212f739678b9","29":"4f7490d4576ca9a020e095326191425324d5a119","30":"63e7e7ad9c72263b1b6de1eaeb77897ad19dcc9e","31":"6cbaa926aa7cbf1b310bdabade1175f9ea86349e","32":"72ab9f9da60abccad5f6434b10739ecdb3a00994","33":"9fb090e53bf584c08a4131c1f050f1a1cd2179f1","34":"b5588167429fc5b42f591634c7e0827fe182346d","35":"component---src-pages-admin-configuration-index-js","36":"component---src-pages-superadmin-company-detail-js","39":"component---cache-caches-gatsby-plugin-offline-app-shell-js","40":"component---src-pages-404-js","41":"component---src-pages-admin-bulkorders-details-js","42":"component---src-pages-admin-bulkorders-index-js","43":"component---src-pages-admin-index-js","44":"component---src-pages-admin-login-js","45":"component---src-pages-admin-orders-details-js","46":"component---src-pages-admin-orders-edit-js","47":"component---src-pages-admin-orders-index-js","48":"component---src-pages-admin-reports-index-js","49":"component---src-pages-admin-shipments-details-box-details-index-js","50":"component---src-pages-admin-shipments-details-index-js","51":"component---src-pages-admin-shipments-index-js","52":"component---src-pages-admin-users-index-js","53":"component---src-pages-app-js","54":"component---src-pages-bulk-[id]-index-js","55":"component---src-pages-bulk-[id]-order-add-js","56":"component---src-pages-bulk-[id]-order-order-id-js","57":"component---src-pages-index-js","58":"component---src-pages-kiosk-index-js","59":"component---src-pages-kiosk-neworder-js","60":"component---src-pages-kiosk-register-js","61":"component---src-pages-login-js","62":"component---src-pages-order-[id]-index-js","63":"component---src-pages-order-edit-[id]-js","64":"component---src-pages-order-new-index-js","65":"component---src-pages-privacy-policy-js","66":"component---src-pages-register-js","67":"component---src-pages-shipmentstatus-track-id-index-js","68":"component---src-pages-superadmin-company-color-modal-picker-js","69":"component---src-pages-superadmin-company-company-account-detail-js","70":"component---src-pages-superadmin-company-company-js","71":"component---src-pages-superadmin-company-index-js","72":"component---src-pages-superadmin-index-js","73":"component---src-pages-superadmin-login-js","74":"component---src-pages-terms-of-service-js"}[chunkId]||chunkId) + "-" + {"0":"8120b1f0fdbcd536eb74","1":"aef20ee6045cf90d8ae0","2":"37ac05e352a9e4b1cad1","3":"ca7cb004728d4a429f9d","4":"d895943e688e93ae69d7","5":"96e0912b5871059dd322","6":"ca835618cf9bde36468c","7":"229e5c318fd438c033dc","8":"9c955b87781faeca5dd4","9":"b065088a91144f8e9d68","10":"5dbe86177a089389f8e1","11":"6daead1fcfbc12811a0b","12":"2f4c15dcdf573b1466e6","13":"5934a8356475526d8f3a","14":"896b75c7a09bc1510373","15":"3ffdd10e85d15c46d211","16":"72fb21565c5bfe3db587","17":"8033bc5b5b86f74c1e90","18":"eb22b6f2b2aa7bb26a40","19":"48ebf2d08ddccfa067c5","20":"d73d9f21a0f79d49c25a","21":"1e9fd14ed1420ea0513a","22":"124b2493f4e4a4a52d1a","23":"fa5440a1b24005f5e11e","24":"5653424b9b551d1f0359","25":"813837b88e6384e06b3e","26":"05c373127657d4507819","27":"4b96c23cdadb8daf5ba9","28":"bf2cd9877beb85f1bbf0","29":"e89c5b5e0b6367d6bc74","30":"1554c98aeb8062be015f","31":"255b1d275ad019dded94","32":"4b9c63170366f43fe2c9","33":"28dd077e71c1bcf09433","34":"3fe5afd27619d0237ec8","35":"c1f1bcb8c69c4f516133","36":"647403ffc5e86ebb7048","39":"29ffee5271a0e1b795d4","40":"a78d4e9e28449be0ecb9","41":"fbf4da7add76438971d8","42":"122c03f345b937d05181","43":"e32319b40f93b41f61ce","44":"894f2a5c39766be096f9","45":"7583e680957e10f70858","46":"c85eb5e24bb419ee62df","47":"4d42bab142e1ea7b89da","48":"acc87464c0cfcd197f08","49":"55500491fc22e3ade8fe","50":"fd6cf0d83da5bc0fd3fb","51":"cd35f0c633c5607d3144","52":"0f394255b2e7a40fe70e","53":"2748c3cbd2217f5190d4","54":"02af91fc1a3a7d6faccb","55":"a9818284225223cfa656","56":"6fbf05ffd7cf83a4a38a","57":"ea9e4c3a95ff511f9090","58":"4a8380ca9157e8603577","59":"ad5f6ce40bc2f09912f7","60":"9cc61e9f1d4efe75b6cd","61":"249f3a7e4c920b59b30a","62":"907362ed505749b6b6f1","63":"d2361199dc44952b09f7","64":"6008ec2bd5866aa23a51","65":"9858cded4504f5a31fc1","66":"6de84a80e5fa6e26c336","67":"473e27182408e4a09921","68":"9ec6548d5d58d705e68b","69":"0aa65189cddace34ad18","70":"2317e2b3c5250d28ac6e","71":"0d3d252f5482b5a66a8f","72":"fb3986148497e3359da2","73":"050f69aff9435762790a","74":"553ea282ebac605cce39"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"16":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"3d81276e2d47b1e065593ec2bc39a6e639c24d24","1":"a7679458f757b8361ace13a33f056b678a76b46c","2":"061b8fceb71bb8d81c977d3bd31bb3ad771b6691","3":"86829105fcece2d88e47c1369debf01e4cd83911","4":"f9cd8ecc1fbc449bd6fdcb9cc73dd4c3735f67ac","5":"19ff34cb0f310556ebd1dd90413ea24ae873f714","6":"8b7dde43d5b7ffc0c27e8df6a260c016dd21b919","7":"b71876d7f0cc283bc2c0951a83e9797af1c0ad31","8":"993423d7e1514d975d30f830e77c1bd06b0e5123","9":"a2a67fd245292ab39c145de116d3036550db830c","10":"cb1608f2","11":"f83b2f6a4429c64aba1966f20a36b987a5dc610e","12":"6d45fb1597c1325fb4b797d476d6c6602382e693","13":"71ac299a32e43abe3eb7a512f79e44c5a02b3eba","14":"5e8c72a52bfd502db71822c4ede0fd5e181aae8c","15":"0235f48bb9b1fadbc49ebe2f6ba5269ac5b94cc8","16":"styles","17":"278ea1445bebd52b140a7a1a064e0d7d66ac2bcc","18":"0119a905e4cf4bb074f4e7592dc2e4e1125c92c6","19":"38c353afb757743b76bdc5d8e51964c745e206fa","20":"4974abce5f84d24f9784d949b3640f81a9a1d3e9","21":"c6b56806421cf466d322078bed31b1b6b618ad13","22":"6c02620f0fb14ecbb80c1d7a1503d54c3d1f0052","23":"5742af7634bdd1f87b1f2e0421e426bfa4fc31c1","24":"7ab772c218f0b94be6d577356d49011e94b4e946","25":"c5a0548ced652622677832e627f1813f7ecbbb40","26":"component---src-pages-admin-users-sender-details-js","27":"0961343f57343142236bf89ad27709698071d114","28":"939e8a034d55a51d1fb271fb1ab6212f739678b9","29":"4f7490d4576ca9a020e095326191425324d5a119","30":"63e7e7ad9c72263b1b6de1eaeb77897ad19dcc9e","31":"6cbaa926aa7cbf1b310bdabade1175f9ea86349e","32":"72ab9f9da60abccad5f6434b10739ecdb3a00994","33":"9fb090e53bf584c08a4131c1f050f1a1cd2179f1","34":"b5588167429fc5b42f591634c7e0827fe182346d","35":"component---src-pages-admin-configuration-index-js","36":"component---src-pages-superadmin-company-detail-js","39":"component---cache-caches-gatsby-plugin-offline-app-shell-js","40":"component---src-pages-404-js","41":"component---src-pages-admin-bulkorders-details-js","42":"component---src-pages-admin-bulkorders-index-js","43":"component---src-pages-admin-index-js","44":"component---src-pages-admin-login-js","45":"component---src-pages-admin-orders-details-js","46":"component---src-pages-admin-orders-edit-js","47":"component---src-pages-admin-orders-index-js","48":"component---src-pages-admin-reports-index-js","49":"component---src-pages-admin-shipments-details-box-details-index-js","50":"component---src-pages-admin-shipments-details-index-js","51":"component---src-pages-admin-shipments-index-js","52":"component---src-pages-admin-users-index-js","53":"component---src-pages-app-js","54":"component---src-pages-bulk-[id]-index-js","55":"component---src-pages-bulk-[id]-order-add-js","56":"component---src-pages-bulk-[id]-order-order-id-js","57":"component---src-pages-index-js","58":"component---src-pages-kiosk-index-js","59":"component---src-pages-kiosk-neworder-js","60":"component---src-pages-kiosk-register-js","61":"component---src-pages-login-js","62":"component---src-pages-order-[id]-index-js","63":"component---src-pages-order-edit-[id]-js","64":"component---src-pages-order-new-index-js","65":"component---src-pages-privacy-policy-js","66":"component---src-pages-register-js","67":"component---src-pages-shipmentstatus-track-id-index-js","68":"component---src-pages-superadmin-company-color-modal-picker-js","69":"component---src-pages-superadmin-company-company-account-detail-js","70":"component---src-pages-superadmin-company-company-js","71":"component---src-pages-superadmin-company-index-js","72":"component---src-pages-superadmin-index-js","73":"component---src-pages-superadmin-login-js","74":"component---src-pages-terms-of-service-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"99286bb03f2ef91a8efe","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
